import React, { useContext, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import image from '../../img/bg5.jpg';
import Grid from '@material-ui/core/Grid';
import { CardBody } from '../Card/CardBody';
import { Card } from '@material-ui/core';
import { AuthContext } from '../../contexts/AuthContext';
import { db } from '../../firebase';
import IconButton from '@material-ui/core/IconButton';
import { useParams } from 'react-router-dom';
import Divider from '@material-ui/core/Divider';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';
import StarOutlineIcon from '@material-ui/icons/StarOutline';
import LinkIcon from '@material-ui/icons/Link';
import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Container from '@material-ui/core/Container';
import Footer from '../../core/Layout/Footer';
import SettingsIcon from '@material-ui/icons/Settings';
import BlogEditDialog from "./BlogEditDialog";

const useStyles = makeStyles((theme) => ({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  resource: {
    position: 'relative',
  },
  overlay: {
    position: 'absolute',
    background: 'rgba(0, 0, 0, 0.5)' /* Black see-through */,
    color: '#f1f1f1',
    opacity: '1',
    padding: '20px',
    textAlign: 'center',
    width: '100%',
    height: '50vh',
    top: '0',
    left: '0',
  },
  image: {
    backgroundImage: `url(${image})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    alignItems: 'center',
    justifyContent: 'center',
    height: '50vh',
    width: '100%',
  },
  heading: {
    marginTop: '15vh',
    fontWeight: 800,
    [theme.breakpoints.down('sm')]: {
      fontSize: '30px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '50px',
    },
  },
  carousal: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '250px',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: '500px',
    },
    margin: '20px auto',
  },
}));

export const BlogPage = () => {
  const classes = useStyles();
  const [blogInfo, setBlogInfo]= useState<any>();
  const { currentUser } = useContext(AuthContext);
  const { id } = useParams();
  useEffect(() => {
    const blogPage = async () => {
      const info = await db.collection('blogs').doc(id).get();
      setBlogInfo(info.data());
      return
    };
    blogPage().then();
  }, []);
  const [openDialog, setOpenDialog] = useState(false);

  const dialogBoxHandler = () => {
    console.log('clicked');
    setOpenDialog(!openDialog);
  };

  return (
      <Grid container component="main" className={classes.container}>
        {/*Heading*/}
        {blogInfo &&
            <Grid item xs={12}>
              <div className={classes.resource}>
                <div className={classes.image} />

                <div
                    style={{
                      zIndex: 3,
                      right: '0',
                      bottom: '0',
                      position: 'absolute',
                    }}
                >
                  <IconButton color="primary" onClick={dialogBoxHandler}>
                    <SettingsIcon/>
                  </IconButton>
                </div>
                <BlogEditDialog defaultValues={blogInfo} openDialog={openDialog} dialogBoxHandler={()=>dialogBoxHandler}/>
                <div className={classes.overlay}>
                  <Typography variant="h5" align="center" className={classes.heading}>
                    {blogInfo.title}
                  </Typography>
                  <Divider
                      variant="inset"
                      light
                      style={{
                        backgroundColor: 'white',
                        width: '50%',
                        margin: '20px auto',
                      }}
                  />
                  <Typography variant="h6" align="center">
                    {blogInfo.sub_title}
                  </Typography>
                </div>

              </div>
            </Grid>}

        {/*What is this*/}
        {blogInfo &&
            <Grid item xs={11}>
              <Card elevation={2} style={{}}>
                <CardBody>
                  <Typography variant="h5">What is {blogInfo.title} ?</Typography>
                  <Divider style={{ margin: '20px' }} />
                  <Typography variant="body1">
                    {blogInfo.description}
                  </Typography>
                  <div className={classes.carousal}>
                    <Carousel>
                      {blogInfo.images.map(image =>
                          <div>
                            <img src={image} alt="img" />
                          </div>)
                      }
                    </Carousel>
                  </div>
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                      <Typography variant="h5" align="center">
                        Impact we made
                      </Typography>
                      <Divider style={{ margin: '10px' }} />
                    </Grid>
                    {blogInfo.impact.map(impact =>
                        <Grid item xs={6} lg={3}>
                          <Card style={{ marginTop: '0' }}>
                            <CardBody>
                              <StarOutlineIcon />
                              <Typography variant="h4">{impact.heading}</Typography>
                              <Typography variant="subtitle1">
                                {impact.sub_heading}
                              </Typography>
                            </CardBody>
                          </Card>
                        </Grid>)
                    }
                    <Grid item xs={12}>
                      <Grid container spacing={3} justifyContent="center">
                        <Container maxWidth="xl">

                          <Grid item xs={12} lg={6} style={{ margin: '10px auto' }}>
                            <Accordion>
                              <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel1a-content"
                                  id="panel1a-header"
                              >
                                <Typography>Key Activities</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <List
                                    component="nav"
                                    aria-label="main mailbox folders"
                                >
                                  {blogInfo.activities.map(activity =>
                                      <ListItem button>
                                        <ListItemIcon>
                                          <StarOutlineIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={activity} />
                                      </ListItem>)
                                  }
                                </List>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                          <Grid item xs={12} lg={6} style={{ margin: '10px auto' }}>
                            <Accordion>
                              <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel2a-content"
                                  id="panel2a-header"
                              >
                                <Typography>Key Outcomes</Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <List
                                    component="nav"
                                    aria-label="main mailbox folders"
                                >
                                  {blogInfo.outcomes.map(outcome =>
                                      <ListItem button>
                                        <ListItemIcon>
                                          <StarOutlineIcon />
                                        </ListItemIcon>
                                        <ListItemText primary={outcome} />
                                      </ListItem>)
                                  }
                                </List>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                          <Grid item xs={12} lg={6} style={{ margin: '10px auto' }}>
                            <Accordion>
                              <AccordionSummary
                                  expandIcon={<ExpandMoreIcon />}
                                  aria-controls="panel2a-content"
                                  id="panel2a-header"
                              >
                                <Typography>
                                  <LinkIcon
                                      style={{
                                        verticalAlign: 'sub',
                                        marginRight: '10px',
                                      }}
                                  />{' '}
                                  Useful Links
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid
                                    container
                                    direction="column"
                                >
                                  {blogInfo.links.map(link =>
                                      <Grid item  style={{textAlign: "justify"}}>
                                        <Button href={link.link} color="primary" >
                                          {link.link_name}
                                        </Button>
                                      </Grid>)
                                  }
                                </Grid>
                              </AccordionDetails>
                            </Accordion>
                          </Grid>
                        </Container>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardBody>
              </Card>
            </Grid>}

        {/*Footer*/}
        <Grid item lg={12}>
          <Footer />
        </Grid>
      </Grid>
  );
};
